class ArticleHistory {
  addToHistory(id) {
    const history = this.getHistory();

    if (this.isInHistory(id)) {
      return;
    }

    history.push(id);

    // Limit length to 100 entries
    if (history.length > 100) {
      history.shift();
    }

    localStorage.setItem("klarnachrichten-article-history", history.join(","));
  }

  isInHistory(id) {
    return this.getHistory().includes(id);
  }

  getHistory() {
    return localStorage.getItem("klarnachrichten-article-history")
      ? localStorage.getItem("klarnachrichten-article-history").split(",")
      : [];
  }
}

window.klarnachrichten.articleHistory = new ArticleHistory();
